//
// Store History of Bootstrap 4 Tabs
// @author: Mark Morris
// TODO: Hate using jQuery but Bootstrap 4 loves it
//

+function ($) {
    'use strict';
    $.fn.historyTabs = function() {
        let hTabs = this;

        // Called when user requests to go back a page
        window.addEventListener('popstate', function(event) {
            if (event.state) {
                $(hTabs).filter('[href="' + event.state.url + '"]').tab('show');
            }
        });

        // Add a new element to history or replace current if its the same
        return this.each(function(index, element) {
            $(element).on('show.bs.tab', function() {

                if (!window.history.pushState || !window.history.replaceState) {
                    return;
                }

                let url = window.location.origin+window.location.pathname+$(this).attr('href');
                let stateObject = {'url' : $(this).attr('href')};
                if (window.location.hash && stateObject.url !== window.location.hash) {
                    window.history.pushState(stateObject, document.title, window.location.pathname + $(this).attr('href'));
                } else {
                    window.history.replaceState(stateObject, document.title, window.location.pathname + $(this).attr('href'));
                }
            });
            if (!window.location.hash && $(element).is('.active')) {
                $(element).tab('show');
            } else if ($(this).attr('href') === window.location.hash) {
                $(element).tab('show');
            }
        });

    };
}(jQuery);
